import { render, staticRenderFns } from "./ChatCx.vue?vue&type=template&id=3937691a&scoped=true"
import script from "./ChatCx.vue?vue&type=script&lang=js"
export * from "./ChatCx.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=3937691a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3937691a",
  null
  
)

export default component.exports